import React from "react";
// import styles from "./styles/ModalConfirm.module.css";
import PropTypes from "prop-types";
import { Modal, Button } from "react-bootstrap";

const ModalConfirm = (props) => {
  const {
    show,
    handleClose,
    onClick,
    title,
    body,
    submitButton,
    showButtonCancel,
  } = props;
  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{body}</Modal.Body>
      {/* <Modal.Body>{`Are you sure to delete course via id ${id}`}</Modal.Body> */}
      <Modal.Footer>
        {showButtonCancel && (
          <Button variant="outline-primary" onClick={handleClose}>
            Cancel
          </Button>
        )}
        <Button
          variant="primary"
          onClick={() => {
            handleClose();
            onClick();
          }}
        >
          {submitButton}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

/* required: display name */
ModalConfirm.displayName = "ModalConfirm";

/* required: props types */
ModalConfirm.propTypes = {
  show: PropTypes.bool,
  handleClose: PropTypes.func,
  onClick: PropTypes.func,
  title: PropTypes.string,
  body: PropTypes.any,
  submitButton: PropTypes.string,
  showButtonCancel: PropTypes.bool,
};

/* required: default props */
ModalConfirm.defaultProps = {
  show: false,
  handleClose: () => {},
  onClick: () => {},
  title: "Delete Course",
  body: "Are you sure to delete course via id",
  submitButton: "Delete",
  showButtonCancel: true,
};

export { ModalConfirm };
